/* imports */
import db from 'db'
import _ from 'lib/lodash'
import { storageAvailable } from 'lib/utils'

/* action types */
export const types = {
	IS_LOADING: 'STICKER/IS_LOADING',
	FETCH_SUCCESS: 'STICKER/FETCH_SUCCESS',
	FETCH_ERROR: 'STICKER/FETCH_ERROR',

	UPDATE_SUCCESS: 'STICKER/UPDATE_SUCCESS',

	RESET_STATE: 'STICKER/RESET_STATE'
};

/* initial state */
export const initialState = {
	isLoading: false,
	error: null,
	sticker: null
};

/* reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case types.IS_LOADING:
			return { ...state, isLoading: true };

		case types.FETCH_ERROR:
			return {	...state, isLoading: false, error: action.error };

		case types.FETCH_SUCCESS:
			return { ...state, isLoading: false, sticker: action.sticker };

		case types.UPDATE_SUCCESS:
			return { ...state, isLoading: false, sticker: action.sticker };

		case types.RESET_STATE:
			return initialState;

		default:
			return state;
	}
}

/* action creators */
export const actions = {
	isLoading: () => ({ type: types.IS_LOADING }),
	fetchError: error => ({ type: types.FETCH_ERROR, error }),
	fetchSuccess: ({sticker}) => ({ type: types.FETCH_SUCCESS, sticker }),

	updateSuccess: ({sticker}) => ({ type: types.UPDATE_SUCCESS, sticker }),

	resetState: () => ({ type: types.RESET_STATE }),
};

export const dispatchActions = {
	resetStickerHandler: () => dispatch => dispatch(actions.resetState()),

	fetchStickerById: (stickerId, tagId) => dispatch => {
		dispatch(actions.isLoading());

		db.fetchStickerById(stickerId, tagId)
			.then(({sticker}) => {
				/* GTM variable */
				if (!!_.get(sticker, 'serialNo')) window.sessionStorage.setItem('serialNo', _.get(sticker, 'serialNo'));

				if (storageAvailable()) {
					const bundleNo = window.sessionStorage.getItem('bundleNo');
					const serialNo = window.sessionStorage.getItem('serialNo');
					const tagType = window.sessionStorage.getItem('tagType');

					if (!!bundleNo) window.dataLayer.push({bundleNo: window.sessionStorage.getItem('bundleNo')});
					if (!!serialNo) window.dataLayer.push({serialNo: window.sessionStorage.getItem('serialNo')});
					if (!!tagType) window.dataLayer.push({tagType: window.sessionStorage.getItem('tagType')});

					window.dataLayer.push({
						"event": "sticker-loaded",
						"eventCategory": `${bundleNo || 'unknown_bundleNo'}/${serialNo || 'unknown_serialNo'}/${tagType || 'unknown_tagType'}`,
						"eventAction": "sticker:loaded"
					}); // make GTM variable available
				}

				dispatch(actions.fetchSuccess({sticker}))
			})
			.catch(error => {
				console.log(error);
				dispatch(actions.fetchError(error))
			});
	},

	handleStickerUpdate: (sticker) => dispatch => {
		db.onStickerUpdate(sticker, (sticker) => dispatch(actions.updateSuccess({sticker})));
	},

	signOut: () => dispatch => db.signOut()
};


// WEBPACK FOOTER //
// ./src/components/sticker/stickerHandlerRedux.jsx